import { render, staticRenderFns } from "./LatestDigitalSignContractsWidget.vue?vue&type=template&id=05df61dc&scoped=true"
import script from "./LatestDigitalSignContractsWidget.vue?vue&type=script&lang=js"
export * from "./LatestDigitalSignContractsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df61dc",
  null
  
)

export default component.exports